/** Static asset locations for the Marathi Akshata 3D template (served from /public). */
export const MARATHI_AKSHATA_TEMPLATE_ID = 'marathi-akshata-3d';
export const ASSET_BASE = '/assets/templates/marathi-akshata-3d';
/**
 * Still used for template cards, previews and the no-WebGL fallback. The banner in it
 * shows the placeholder names ("Bride Name" / "Groom Name"), never a real couple.
 */
export const POSTER_URL = `${ASSET_BASE}/poster.jpg`;
/**
 * Default ambient track for the audio toggle. Reuses an asset already shipped for
 * another wedding template (no new download unless the guest turns music on:
 * the <audio> element uses preload="none"). Hosts can override it with
 * customData.musicUrl / experience.meta.musicUrl / customData.music.url.
 */
export const DEFAULT_MUSIC_URL = '/assets/royal-ganesh-interactive/music.mp3';
